import React from 'react';


function Career() {

    return (
        /*<ol class="MethodWrapper">*/
        <ul>
            <li>KAIST BS(EE&CS), MS(EE), and PhD(CS)</li>
            <li>Senior Researcher, Samsung</li>
            <li>Attorney, Dr. Park Law Office</li>
            <li>Associate Prof., Dong-A Univ. Law School (Present)</li>
            <li>Arbitrator, Korean Commercial Arbitration Board (Present)</li>
        </ul>); 
}

export default Career;